import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { registerLocaleData, CommonModule } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClient } from '@angular/common/http';
import { MatCarouselModule } from '@ngbmodule/material-carousel';
import {
  TranslateModule,
  TranslateLoader,
  MissingTranslationHandler,
} from '@ngx-translate/core';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { AppRoutingModule } from 'app/app-routing.module';
import { appInitializerProviders } from 'app/shared/apiInitializerProviders';
import { ApiMissingTranslationHandler } from 'app/shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from 'app/shared/apiTranslationLoader';
import { httpInterceptorProviders } from 'app/shared/http-interceptors';
import { MaterialModule } from 'app/shared/material/material.module';
import { ChartsModule } from 'ng2-charts';
import { CameraInfoSmartWasteComponent } from './camera-info-smart-waste/camera-info-smart-waste.component';
import { AllviewComponent } from './dashboard/allview/allview.component';
import { CameraComponent } from './dashboard/camera/camera.component';
import { WasteComponent } from './dashboard/waste/waste.component';
import { HistoriqueComponent } from './historique/historique.component';
import { ListWasteComponent } from './list-waste/list-waste.component';
import { ImagePreviewComponent } from './miniature/image-preview/image-preview.component';
import { MiniatureComponent } from './miniature/miniature.component';
import { SmartwasteCameraComponent } from './smartwaste-camera/smartwaste-camera.component';
import { FormStatusComponent } from './smartwaste-dashboard/form-status/form-status.component';
import { SmartwasteDashboardComponent } from './smartwaste-dashboard/smartwaste-dashboard.component';
import { SmartwasteHomeComponent } from './smartwaste-home/smartwaste-home.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { VideoTimelineComponent } from './video-timeline/video-timeline.component';
import { VideoWasteComponent } from './video-waste/video-waste.component';
import { MatStepperModule } from '@angular/material/stepper';
import localeFr from '@angular/common/locales/fr';
import { ANPRHomeComponent } from './anpr-home/anpr-home.component';
import { CurrentLicenseComponent } from './anpr-home/current-license/current-license.component';
import { HistoryComponent } from './anpr-home/history/history.component';
import { AnprZoneComponent } from './anpr-home/anpr-zone/anpr-zone.component';

registerLocaleData(localeFr, 'fr');

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

@NgModule({
  declarations: [
    SmartwasteHomeComponent,
    SmartwasteDashboardComponent,
    ListWasteComponent,
    SmartwasteCameraComponent,
    WasteComponent,
    CameraComponent,
    AllviewComponent,
    VideoWasteComponent,
    HistoriqueComponent,
    ThumbnailComponent,
    MiniatureComponent,
    ImagePreviewComponent,
    CameraInfoSmartWasteComponent,
    VideoTimelineComponent,
    FormStatusComponent,
    ANPRHomeComponent,
    CurrentLicenseComponent,
    HistoryComponent,
    AnprZoneComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MaterialModule,
    MatStepperModule,
    IvyCarouselModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC7Wt3VDl1byLs_VXiNhxq3HKcOwWofB8Y',
    }),
    AgmJsMarkerClustererModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    MatCarouselModule.forRoot(),
    ChartsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler,
      },
    }),
  ],
  exports: [],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class SmartwasteModule {}
